import * as React from "react"
const SvgUp = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m11.995 10.961-3.904 3.906a.95.95 0 0 1-.7.276.95.95 0 0 1-.7-.276.95.95 0 0 1-.276-.7.95.95 0 0 1 .275-.702l4.604-4.607q.15-.15.326-.213.175-.062.375-.062c.2 0 .259.02.375.062a.9.9 0 0 1 .326.213l4.604 4.607a.95.95 0 0 1 .275.701.95.95 0 0 1-.275.701.95.95 0 0 1-.7.276.95.95 0 0 1-.702-.276z" />
  </svg>
)
export default SvgUp
